import React, {useEffect, useState} from "react";
import styled from "styled-components";
import currentTheme from "../../react-themes/theme";
import {t} from "../../shared-services/translate";
import axios from "axios";
import {trackEvent} from "../../services/tracking-helper";

const theme = currentTheme();

// Newsletter email check expression
const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

const mobileBreakpoint = "850px";

const NewsletterForm = (props) => {
  const locale = window.I18n.locale || "de";

  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [subscribed, setSubscribed] = useState(false);

  const onNewsletterEmailChange = e => setNewsletterEmail(e.target.value);

  const onNewsLetterSubmit = e => {
    e.preventDefault();
    axios.post(`/api/frontend/newsletter/subscribe_user.json?locale=${locale}`, {email: newsletterEmail})
      .then(async function(response) {
        window.Alerts.success(response.data?.message);
        setSubscribed(true);
        trackEvent("newsletter", {userDetails: {email: newsletterEmail}});
      }).catch(error => {
        const errorMessage = error.response?.data?.error_message || error.message;
        window.Alerts.error(errorMessage);
      });
  };

  useEffect(() => {
    emailRegex.test(newsletterEmail) ? setIsDisabled(false) : setIsDisabled(true);
  }, [newsletterEmail]);

  return <StyledNewsletterForm className={`${subscribed && "hidden-form"}`} onSubmit={onNewsLetterSubmit}>
    <input type='email' value={newsletterEmail} onChange={onNewsletterEmailChange} placeholder={t("spree.newsletters.subscribe_email.placeholder")}/>
    <button type='submit' className='btn btn-primary btn-sm full-height' disabled={isDisabled}>{t("home.start.newsletter.cta")}</button>
  </StyledNewsletterForm>;
};

export default NewsletterForm;

const StyledNewsletterForm = styled.form`
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  height: 30px;
  overflow: hidden;

  &.hidden-form {
    display: none;
  }

  @media (max-width: ${mobileBreakpoint}) {
    justify-content: center;
    width: 80%;
  }

  input {
    width: 80%;
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid #d1d1d1;
    border-radius: 3px 0 0 3px ;

    &::placeholder {
      opacity: 70%;
    }

    &:focus {
      outline: none;
      border-color: ${theme.colors.farmy.orange};
      box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(242,111,0,0.6);
    }
  }
  button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0 ;
  }
`;
